var map = {
	"./boost.jpg": "5dd7",
	"./ensure-diabetes.jpg": "52db",
	"./ensure-vanilla.jpg": "ee9b",
	"./horlicks.jpg": "da77",
	"./pediasure-vanilla.jpg": "6baa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7777";